'use strict';

import { view } from '@/functions';

const prefix = '/admins';
export default [
    {
        path: prefix,
        name: 'admins',
        meta: {
            title: 'Admins',
            scopes: ['read_admins', 'write_admins']
        },
        component: () => view('admins/index')
    },
    {
        path: `${prefix}/:id/edit`,
        name: 'edit-admin',
        meta: {
            title: 'Edit admin',
            scopes: ['write_admins']
        },
        component: () => view('admins/edit')
    },
    {
        path: `${prefix}/invite`,
        name: 'invite-admin',
        meta: {
            title: 'Invite admin',
            scopes: ['write_admins']
        },
        component: () => view('admins/invite')
    },
];
